import { render } from "./CarouselItem.vue?vue&type=template&id=5f2fc360"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=5f2fc360&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__